import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SectionContainer, SectionTitle } from '../styles';
import { Player } from './components/Player';
import { ImageContainer, ImageContainerWrapper, TitleContainer, } from './styles';
export var Media = function (_a) {
    var section = _a.section;
    return (_jsxs(SectionContainer, { children: [section.pageTitle && (_jsx(TitleContainer, { children: _jsx(SectionTitle, { children: section.pageTitle }, void 0) }, void 0)), section.link ? (_jsx(Player, { link: section.link }, void 0)) : (_jsx(ImageContainerWrapper, { children: _jsx(ImageContainer, { "$image": section.image }, void 0) }, void 0))] }, void 0));
};
